/**
 * Branding Configuration - My Riad Manager
 * Centralise toutes les informations de branding
 */

export const BRANDING = {
  name: 'My Riad Manager',
  shortName: 'MRM',
  domain: 'myriadmanager.com',
  url: 'https://myriadmanager.com',
  tagline: 'Gérez votre riad simplement et efficacement',
  copyright: '© 2026 My Riad Manager',
  pdfFooter: 'Document généré par My Riad Manager',
  logo: '/logo.svg'
};

export default BRANDING;
